// src/components/Learning/Learning.js
import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

import Header from "./LearningPageHeader";
import Footer from "./LearningPageFooter";

import LearningHeroSection from "./LearningPage/LearningHeroSection";
import WhoItsForSection from "./LearningPage/WhoItsForSection";
import ProgramFormatSection from "./LearningPage/ProgramFormatSection";
import DifferentiationSection from "./LearningPage/DifferentiationSection";
import CapabilitySection from "./LearningPage/CapabilitySection";
import OutcomesSection from "./LearningPage/OutcomesSection";
import InstructorSection from "./LearningPage/InstructorSection";
import LearningCTASection from "./LearningPage/LearningCTASection";
import LearningFAQSection from "./LearningPage/LearningFAQSection";
import TakeawaysSection from "./LearningPage/TakeawaysSection";
import ProgramDetailsSection from "./LearningPage/ProgramDetailsSection";

/*
import WhatYouLearnSection from "./LearningPage/WhatYouLearnSection";

*/
import AOS from "aos";
import "aos/dist/aos.css";

const Learning = () => {

    useEffect(() => {
        AOS.init({
            once: true,
            duration: 250,
            easing: "ease-out-cubic",
            offset: 80,
            disable: "prefers-reduced-motion",
        });
    }, []);

    return (
        <>
            <Helmet>
                <title>
                    Learn How Growth Decisions Are Made | Buzz To Brand
                </title>

                <meta
                    name="description"
                    content="A live, closed-group program for early career professionals to learn how real growth decisions are made across acquisition, conversion, engagement, and retention."
                />

                <link
                    rel="canonical"
                    href="https://buzztobrand.com/learning"
                />
            </Helmet>

            <main>
                <Header />
                <LearningHeroSection />
                <WhoItsForSection />
                <ProgramFormatSection />
                <DifferentiationSection />
                <CapabilitySection />
                <OutcomesSection />
                <InstructorSection />
                <ProgramDetailsSection />
                <TakeawaysSection />
                <LearningCTASection />
                <LearningFAQSection />
                <Footer />
                {/*
                <WhatYouLearnSection />
                */}
            </main>


        </>
    );
};

export default Learning;
